import React from "react"
import { styles } from "../styles"
import { motion } from "framer-motion"
import { fadeIn, textVariant } from "../utils/motion"
import { SectionWrapper } from "../hoc"
const Services = ({ index }) => {
  return (
    <div className="bg-white-100 pt-20 overflow-hidden">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={textVariant(0.3)}
      >
        <p
          className={`${styles.sectionHeadTextServices} `}
          style={{ fontFamily: "Montserrat" }}
        >
          Services
        </p>
      </motion.div>
      <div className="flex justify-center  p-8  md:p-20 ">
        <div className="services-grid grid grid-cols-2 lg:grid-cols-3  w-full md:w-8/12 shadow-card text-sm leading-9 ">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("right", "spring", index * 0.7, 1)}
            className="hover-effect "
          >
            <span className="">Architectural Design</span>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("down", "spring", index * 0.7, 1)}
            className="hover-effect"
          >
            <span className="">Interior Design</span>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("left", "spring", index * 0.7, 1)}
            className="hover-effect"
          >
            <span className="">Urban Planning</span>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("right", "spring", index * 0.7, 1)}
            className="hover-effect"
          >
            <span className="">Sustainable Design</span>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("up", "spring", index * 0.7, 1)}
            className="hover-effect"
          >
            <span className="">Construction Management</span>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={fadeIn("left", "spring", index * 0.7, 1)}
            className="hover-effect "
          >
            <span className="">Liasoning</span>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default SectionWrapper(Services, "services")
